import { Data, Model, Utils } from "@singularsystems/neo-core";
import { AxiosPromise } from "axios";
import { injectable } from "inversify";
import { AppService, Types } from "../../App/Services/AppService";
import CommandResult from "../../Common/Models/CommandResult";
import UpdateCorporateActionEventCommand from "../CorporateActionEvents/Models/Commands/UpdateCorporateActionEventCommand";
import CorporateActionEventLookup from "../CorporateActionEvents/Models/Lookups/CorporateActionEventLookup";
import CorporateActionStatusDropDownLookup from "../CorporateActionEvents/Models/Lookups/CorporateActionStatusDropDownLookup";
import CorporateActionEventSearchCriteria from "../CorporateActionEvents/Models/Queries/CorporateActionEventSearchCriteria";
import CompleteCorporateActionEventCommand from "../CorporateActionEvents/Models/Commands/CompleteCorporateActionEventCommand";

export interface ICorporateActionEventsApiClient {
    getCorporateActionEventsPagedList(payload: Model.PartialPlainNonTrackedObject<Data.PageRequest<CorporateActionEventSearchCriteria>>): AxiosPromise<Data.PageResult<Model.PlainObject<CorporateActionEventLookup>>>;
    getCorporateActionStatusListByCriteria(criteria: string): AxiosPromise<Array<Model.PlainObject<CorporateActionStatusDropDownLookup>>>;
    updateCorporateActionEvent(command: Model.PlainObject<UpdateCorporateActionEventCommand>): AxiosPromise<Model.PlainObject<CommandResult>>;
    completeCorporateActionEvent(command: Model.PlainObject<CompleteCorporateActionEventCommand>): AxiosPromise<Model.PlainObject<CommandResult>>;
}

@injectable()
export default class CorporateActionEventsApiClient extends Data.ApiClientBase implements ICorporateActionEventsApiClient {

    constructor(config = AppService.get(Types.Config)) {
        super(`${config.apiPath}/CorporateActionEvent`)
    }

    public getCorporateActionEventsPagedList(payload: Model.PartialPlainNonTrackedObject<Data.PageRequest<CorporateActionEventSearchCriteria>>): AxiosPromise<Data.PageResult<Model.PlainObject<CorporateActionEventLookup>>> {
        return this.axios.get(`${this.apiPath}/GetCorporateActionEventsPagedList?${Utils.getQueryString(payload)}`);
    }

    public getCorporateActionStatusListByCriteria(criteria: string): AxiosPromise<Array<Model.PlainObject<CorporateActionStatusDropDownLookup>>> {
        return this.axios.get(`${this.apiPath}/GetCorporateActionStatusListByCriteria`, { params: { criteria: criteria }});
    }

    public updateCorporateActionEvent(command: Model.PlainObject<UpdateCorporateActionEventCommand>): AxiosPromise<Model.PlainObject<CommandResult>> {
        return this.axios.post(`${this.apiPath}/UpdateCorporateActionEvent`, command);
    }

    public completeCorporateActionEvent(command: Model.PlainObject<CompleteCorporateActionEventCommand>): AxiosPromise<Model.PlainObject<CommandResult>> {
        return this.axios.post(`${this.apiPath}/CompleteCorporateActionEvent`, command);
    }
}